import { Classes, Drawer } from "@blueprintjs/core";
import classNames from "classnames";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { handleNavigation } from "../../../utils/domUtils";
import AtIcon from "../../atoms/AtIcon";
import LazyThumbnail from "../../pages/DesignBrowser/LazyThumbnail";
import { thumbnailTemplates } from "../../pages/EntryPage/defaultflags";
import DesignSearchBar from "../DesignSearch/DesignSearchBar";
import { useDesignListState } from "../../../reducers/designlist.reducer";
import strings from "../../../strings";
import DesignSearchResults from "../DesignSearch/DesignSearchResults";
const CollectionBrand = props => {
  const {
    Tree,
    handleThumbnailClick,
    level = 0,
    defaultFolder,
    selectedFile,
    className = "",
    showNavigatorArrows = true
  } = props;
  const [nagivatorArrowsNeeded, setNagivatorArrowsNeeded] = useState(false);
  const thumbContainerRef = useRef(null);
  const designListState = useDesignListState();
  const { sizeFilter, tagFilter } = designListState;
  const Folders = Tree.children || [];
  const nodeItems = Folders.filter(
    node => node && (node.children.length || node.files.length) && node.name.charAt(0) !== "."
  );
  const [selectedFolder, setSelectedFolder] = useState(
    defaultFolder ? defaultFolder : nodeItems.length ? nodeItems[0] : null
  );

  const [childNode, setChildNode] = useState([]);
  const [selectedChildNode, setSelectedChildNode] = useState(
    childNode.length ? childNode[0] : null
  );
  const [textToSearch, setTextToSearch] = useState("");
  const [showSearchResults, setShowSearchResults] = useState("none");
  const [showCateogryDrawer, setShowCategoryDrawer] = useState(false);

  const handleDrawer = () => {
    setShowCategoryDrawer(!showCateogryDrawer);
  };
  const checkScrollbar = () => {
    const el = thumbContainerRef.current;
    if (!el) return;

    const check = () => {
      const hasScroll = el.scrollWidth > el.clientWidth;
      setNagivatorArrowsNeeded(hasScroll);
    };

    // Run immediately
    check();

    // Observe size/content changes
    const resizeObserver = new ResizeObserver(check);
    resizeObserver.observe(el);

    // Also check on window resize
    window.addEventListener("resize", check);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", check);
    };
  };

  useEffect(() => {
    checkScrollbar(); // run initially

    const folderName = selectedFile?.location.split("/").pop();
    const node = Folders.find(item => item.name === folderName);
    if (node) {
      setSelectedFolder(node);
      const childNode =
        node.name != "Designs" && node.children.filter(node => node && node.name.charAt(0) !== ".");
      setChildNode(childNode);
      setSelectedChildNode(childNode.length && node.files.length == 0 ? childNode[0] : null);
    }
  }, []);

  useEffect(() => {
    // Wait for DOM to update when folder is clicked
    setTimeout(checkScrollbar, 0);
  }, [selectedFolder]);

  const onFolderClick = node => {
    setSelectedFolder(node);
    const childNode =
      node.name != "Designs" && node.children.filter(node => node && node.name.charAt(0) !== ".");
    setChildNode(childNode);
    setSelectedChildNode(childNode.length && node.files.length == 0 ? childNode[0] : null);
    setShowCategoryDrawer(false);
  };

  const handleNavigator = direction => {
    const elem = thumbContainerRef.current;
    handleNavigation({ elem, direction });
  };

  const handleSearch = e => {
    let text = e.target.value;
    setTextToSearch(text);
    if (text.length > 2) {
      setShowSearchResults("design");
    } else if (text === "") {
      if (!sizeFilter.find(item => !!item.selected)) setShowSearchResults("none");
      //else if (tagFilter === "") setShowSearchResults("none");
      else {
        setShowSearchResults("design");
      }
      setTextToSearch("");
    }
  };

  const handleCancel = () => {
    setTextToSearch("");
    if (tagFilter === "") setShowSearchResults("none");
  };

  const handleFilterDesigns = (filter, e) => {
    if (!filter && textToSearch.length <= 2) {
      setShowSearchResults("none");
    }
    if (showSearchResults !== "design") setShowSearchResults("design");
  };

  const FoldersTree = () => {
    return (
      <ul className="category-folder">
        {Tree && Tree.files?.length ? (
          <div
            className={classNames("tree-content-folders base-folder", {
              selected: selectedFolder.name === Tree.name
            })}
            onClick={() => onFolderClick(Tree)}
            datatitle={"Home"}
          >
            <li className="cyr-collection-category">
              <span>{"Home"}</span>
            </li>
          </div>
        ) : null}

        {nodeItems.map((node, index) => (
          <div
            className={classNames("tree-content-folders", {
              selected: selectedFolder.name === node.name
            })}
            key={index}
            datatitle={node.name || ""}
          >
            <li className="cyr-collection-category" onClick={() => onFolderClick(node)}>
              <span>{node.name}</span>
            </li>

            <ul style={{ padding: "0 4rem" }}>
              {childNode.length > 0 &&
                selectedFolder.name == node.name &&
                childNode.map(
                  (node, index) =>
                    node.files.length != 0 && (
                      <div
                        className={classNames("tree-content-folders child-folder", {
                          selected: selectedChildNode ? selectedChildNode.name === node.name : false
                        })}
                        key={index}
                        onClick={() => setSelectedChildNode(node)}
                        datatitle={node.name || ""}
                      >
                        <li className={classNames("cyr-collection-category-child")}>
                          <span>{node.name}</span>
                        </li>
                      </div>
                    )
                )}
            </ul>
          </div>
        ))}
      </ul>
    );
  };

  return (
    <>
      <div className="searchBarDiv">
        <DesignSearchBar
          handleInputChange={e => handleSearch(e)}
          placeholder={strings.design.searchDesigns}
          textToSearch={textToSearch}
          handleCancel={handleCancel}
          handleFilter={handleFilterDesigns}
          type="design"
        />
      </div>
      <DesignSearchResults
        hidden={showSearchResults !== "design"}
        id="designSearchResults"
        textToSearch={textToSearch}
        type="design"
      />
      {showSearchResults == "none" && (
        <>
          <div className="cyr-collection-mobileView">
            <div className="cyr-collection-header">
              <AtIcon icon="hamburger-menu" size={2.5} onClick={handleDrawer} />
              <Drawer
                isOpen={showCateogryDrawer}
                isCloseButtonShown={true}
                position="left"
                title="Collections"
                onClose={handleDrawer}
              >
                <FoldersTree />
              </Drawer>
              <div className="cyr-header-name">
                <h1>{selectedFolder && selectedFolder.name}</h1>
                <h2>{selectedChildNode && selectedChildNode.name}</h2>
              </div>
            </div>

            <div className="cyr-thumbs-container">
              {selectedChildNode ? (
                <div
                  className={classNames("design-controller__thumbs-area__container", {
                    templateGrid: window.flags.thumbnailTemplate !== thumbnailTemplates.DesignOnly
                  })}
                  ref={thumbContainerRef}
                >
                  {selectedChildNode.files.map((file, index) => (
                    <LazyThumbnail
                      aspect="portrait"
                      onThumbnailClick={() =>
                        handleThumbnailClick && handleThumbnailClick(file, index)
                      }
                      key={index}
                      node={file}
                      className={classNames({ active: file.fullPath === selectedFile?.fullPath })}
                    />
                  ))}
                </div>
              ) : (
                <div
                  className={classNames("design-controller__thumbs-area__container", {
                    templateGrid: window.flags.thumbnailTemplate !== thumbnailTemplates.DesignOnly
                  })}
                  ref={thumbContainerRef}
                >
                  {selectedFolder.files.map((file, index) => (
                    <LazyThumbnail
                      aspect="portrait"
                      onThumbnailClick={() =>
                        handleThumbnailClick && handleThumbnailClick(file, index)
                      }
                      key={index}
                      node={file}
                      className={classNames({ active: file.fullPath === selectedFile?.fullPath })}
                    />
                  ))}
                </div>
              )}
              {showNavigatorArrows && nagivatorArrowsNeeded && (
                <div className="cyr-arrows-container">
                  <AtIcon
                    className="navigator-arrows right"
                    icon="chevron-right"
                    onClick={() => handleNavigator("right")}
                  />
                  <AtIcon
                    className="navigator-arrows"
                    icon="chevron-left"
                    onClick={() => handleNavigator("left")}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="folder-container">
            <FoldersTree />

            <div className="cyr-thumbs-container">
              {selectedChildNode ? (
                <div
                  className={classNames("design-controller__thumbs-area__container", {
                    templateGrid: window.flags.thumbnailTemplate !== thumbnailTemplates.DesignOnly
                  })}
                  style={
                    selectedChildNode.files.length > 10
                      ? {
                          gridAutoFlow: "column"
                        }
                      : {}
                  }
                  ref={thumbContainerRef}
                >
                  {selectedChildNode.files.map((file, index) => (
                    <LazyThumbnail
                      aspect="portrait"
                      onThumbnailClick={() =>
                        handleThumbnailClick && handleThumbnailClick(file, index)
                      }
                      key={index}
                      node={file}
                      className={classNames({ active: file.fullPath === selectedFile?.fullPath })}
                    />
                  ))}
                </div>
              ) : (
                <div
                  className={classNames("design-controller__thumbs-area__container", {
                    templateGrid: window.flags.thumbnailTemplate !== thumbnailTemplates.DesignOnly
                  })}
                  ref={thumbContainerRef}
                  style={selectedFolder.files.length > 10 ? { gridAutoFlow: "column" } : {}}
                >
                  {selectedFolder.files.map((file, index) => (
                    <LazyThumbnail
                      aspect="portrait"
                      onThumbnailClick={() =>
                        handleThumbnailClick && handleThumbnailClick(file, index)
                      }
                      key={index}
                      node={file}
                      className={classNames({ active: file.fullPath === selectedFile?.fullPath })}
                    />
                  ))}
                </div>
              )}

              {showNavigatorArrows && nagivatorArrowsNeeded && (
                <div className="cyr-arrows-container">
                  <AtIcon
                    className="navigator-arrows right"
                    icon="chevron-right"
                    onClick={() => handleNavigator("right")}
                  />
                  <AtIcon
                    className="navigator-arrows"
                    icon="chevron-left"
                    onClick={() => handleNavigator("left")}
                  />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

CollectionBrand.propTypes = {};

export default CollectionBrand;
